module.exports = __webpack_public_path__ + "img/child-profile-empty-plus.43d74e68.png";